module.exports = __webpack_public_path__ + "img/eye.c2bb22d4.svg";